import React from 'react';
import { array, arrayOf, object, string } from 'prop-types';

import { FormattedMessage } from '../../util/reactIntl';
import { REVIEW_TYPE_OF_PROVIDER, propTypes } from '../../util/types';
import { richText } from '../../util/richText';
import { AvatarLarge, H2, H4, Reviews } from '../../components';

import SectionDetailsMaybe from '../ProfilePage/SectionDetailsMaybe';

import css from './ArtistProfilePage.module.css';

const MIN_LENGTH_FOR_LONG_WORDS = 20;

const ArtistHeader = props => {
  const { user, displayName, bio, publicData, metadata, userFieldConfig, reviews, intl } = props;

  const hasBio = !!bio;
  const bioWithLinks = richText(bio, {
    linkify: true,
    longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
    longWordClass: css.longWord,
  });

  const reviewsOfArtist = reviews.filter(r => r.attributes.type === REVIEW_TYPE_OF_PROVIDER);

  return (
    <div className={css.header}>
      <AvatarLarge className={css.avatar} user={user} disableProfileLink />
      <div className={css.headerInfo}>
        <H2 as="h1" className={css.heading}>
          <FormattedMessage id="ArtistProfilePage.heading" values={{ name: displayName }} />
        </H2>
        {hasBio ? <p className={css.bio}>{bioWithLinks}</p> : null}
        <SectionDetailsMaybe
          publicData={publicData}
          metadata={metadata}
          userFieldConfig={userFieldConfig}
          intl={intl}
        />
        {reviewsOfArtist.length > 0 ? (
          <div className={css.reviews}>
            <H4 as="h2" className={css.reviewsTitle}>
              <FormattedMessage
                id="ArtistProfilePage.reviewsTitle"
                values={{ count: reviewsOfArtist.length }}
              />
            </H4>
            <Reviews reviews={reviewsOfArtist} />
          </div>
        ) : null}
      </div>
    </div>
  );
};

ArtistHeader.defaultProps = {
  user: null,
  displayName: null,
  bio: null,
  publicData: null,
  metadata: null,
  userFieldConfig: null,
  reviews: [],
};

ArtistHeader.propTypes = {
  user: propTypes.user,
  displayName: string,
  bio: string,
  publicData: object,
  metadata: object,
  userFieldConfig: array,
  reviews: arrayOf(propTypes.review),
};

export default ArtistHeader;
